<template>
  <v-row no-gutters class="white">
    <v-col align="end" class="pa-2" style="text-align: end;">
      <v-btn :ripple="false" icon @click="closeAction">
        <v-icon color="grey" x-large>mdi-close</v-icon>
      </v-btn>
    </v-col>
  </v-row>
</template>

<script>
  export default {
    mixins: [],
    components:{
    },
    props:{
    },
    methods:{
      closeAction(){
        this.$emit('close');
      }
    }
  }
</script>

<style>
.acco_carousel_img_slider .v-window__prev,.acco_carousel_img_slider .v-window__next{
  background: none!important;
}
.acco_carousel_img_slider .window__next.v-btn.v-btn__content.v-icon{
  font-size:100px!important;
}
</style>
